import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CalendarModule, CalendarUtils, DateAdapter, CalendarView, CalendarA11y, CalendarDateFormatter } from 'angular-calendar';
import { Subject } from 'rxjs';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import multiMonthPlugin from '@fullcalendar/multimonth'
import interactionPlugin from '@fullcalendar/interaction';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatChipsModule} from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SubRouteFrequenciesService } from '../../sub-routes-frequency/sub-route-frequency.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import FrequenciesAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { FuseLoadingService } from '@fuse/services/loading';
import { SubRouteFrequenciesBPService } from '../../sub-routes-frequency/sub-route-frequencies-bp.service';
import { ICreateAppointment, ICreateManyBPFrecuency } from '../../sub-routes-frequency/interfaces/create-sub-route-bp-frequency';

@Component({
  selector: 'app-calendar-periodicity',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    CalendarModule,
    FullCalendarModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    MatDatepickerModule,
    MatChipsModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './calendar-periodicity.component.html',
  styleUrl: './calendar-periodicity.component.scss',
  providers: [
    CalendarUtils,
    CalendarA11y,
    CalendarDateFormatter,
    {
      provide: DateAdapter,
      useFactory: adapterFactory
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CalendarPeriodicityComponent {

  frecuency: string| null = null

  selectedDays: number[] = [];
  selectedDate: Date | null = null;
  selectedEndDate: Date | null = null;
  selectedDateAgend: Date | null = null
  selectedDates: Date[] = [];
  
  isCalendarVisible: boolean = false;

  listFrecuency = [
    {code: 'W', name:'Día'}, //el dia se manda
    {code: 'S', name:'Semana'}, //fecha
    {code: 'Q', name:'Quincena'}, //fecha
    {code: 'M', name:'Mes'}, //fecha
    {code: 'P', name:'Año'}, //personalizado(dates) se debe mantener al cambiar la fecha
    {code: 'C', name:'Agenda'}
  ]

  daysList: { code: number; day: string }[] = [
    {code: 1, day: "LU"},
    {code: 2, day: "MA"},
    {code: 3, day: "MI"},
    {code: 4, day: "JU"},
    {code: 5, day: "VI"},
    {code: 6, day: "SA"},
    {code: 7, day: "DO"}
  ];

  listFrecuencies: any[] = [];
  selectedFrecuency: { _id: string; days: number[], businessPartners: BusinessPartnerAttributes[] } | null = null;

  view: CalendarView = CalendarView.Month;
  calendarOptions: any = {
    plugins: [multiMonthPlugin, interactionPlugin],
    initialView: 'multiMonthFourMonth',
    views: {
      multiMonthFourMonth: {
        type: 'multiMonth',
        duration: { months: 12 },
        buttonText: 'Year',
      },
    },
    events: [],
    headerToolbar: false,
    locale: 'es'
  };

  eventsFrecuency = []
  private _fuseLoadingService = inject(FuseLoadingService);
 
  constructor(
    public dialogRef: MatDialogRef<CalendarPeriodicityComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly frequencyService: SubRouteFrequenciesService,
    private subRouteFrequenciesBPService: SubRouteFrequenciesBPService,
    private snackBar: MatSnackBar
  ) { 
    /* {
      subRouteId: this.data._id,
      businessPartners: [],
      frecuencySelected: null
    } */
  }

  ngOnInit(): void {
    this.dialogRef.updateSize("90%");
    this.getListFrecuencies();
  }

  getListFrecuencies(): void {
    this.frequencyService.findBySubRouteId(this.data.subRouteId).subscribe({
      next: (response) => {
        const filteredFrequencies = response?.data?.filter((frequency: any) => frequency.type === 'W') || [];
        this.listFrecuencies = filteredFrequencies
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || 'Error al obtener las frecuencias',
          'Cerrar',
          { duration: 5000 }
        );
      },
    });
  }

  getFrecuencyDays(days: number[]): string {
    // Convertimos los códigos de días en nombres
    return days
      .map((dayCode) => this.daysList.find((day) => day.code === dayCode)?.day)
      .join('-');
  }

  isMonthlyOrQuarterly(): boolean {
    return this.frecuency === 'S' || this.frecuency === 'Q' || this.frecuency === 'M' || this.frecuency === 'P';
  }

  today() {
    return new Date()
  }

  limitDate(){
    const selectedDate = new Date(this.selectedDate);
    selectedDate.setFullYear(selectedDate.getFullYear() + 1); //limite de years cuando se tiene fecha fin
    return selectedDate;
  }

  changeFrecuency(): void {
    this.isCalendarVisible = false
    this.selectedDate = null
    this.selectedEndDate = null
    
    if(this.frecuency == 'S' || this.frecuency === 'Q' || this.frecuency === 'M' || this.frecuency === 'P'){
      this.selectedFrecuency = null
      this.selectedDays = []
      this.selectedDateAgend = null
      this.selectedDates = []
    }else if(this.frecuency == 'C'){
      this.selectedFrecuency = null
      this.selectedDays = []
    }else{
      this.selectedDateAgend = null
      this.selectedDates = []
    }
  }

  //dia
  onDaySelectionChange(day: { code: number; selected?: boolean }): void {
    if (day.selected) {
      if (!this.selectedDays.includes(day.code)) {
        this.selectedDays.push(day.code); // Agrega el código del día seleccionado
      }
    } else {
      this.selectedDays = this.selectedDays.filter((code) => code !== day.code); // Elimina el código del día deseleccionado
    }
  }

  //agenda
  addDate(): void {
    if (this.selectedDateAgend) {
      const selectedDate = new Date(this.selectedDateAgend);
      if (!this.selectedDates.some((date: any) => {
        const currentDate = new Date(date);
        return currentDate.toISOString() === selectedDate.toISOString();
      })) {
        this.selectedDates.push(selectedDate);
      }
  
      this.selectedDateAgend = null;
    }
  }

  removeDate(date: Date): void {
    this.selectedDates = this.selectedDates.filter((d) => d.getTime() !== date.getTime());
  }

  openCalendar(): void {
    this._fuseLoadingService.show();

    setTimeout(() => {
      this.isCalendarVisible = true;
   
      let events = [];
      if (this.selectedFrecuency && this.selectedFrecuency.days && this.selectedFrecuency.days.length > 0) {
        let currentDate = new Date();
        const endDate = new Date(currentDate);
        endDate.setFullYear(currentDate.getFullYear() + 1); // Aumentar un año
  
        while (currentDate <= endDate) {
          const currentDayCode = (currentDate.getDay() === 0) ? 7 : currentDate.getDay(); // 0 (domingo) -> 7 (domingo)
          
          if (this.selectedFrecuency.days.includes(currentDayCode)) {
            events.push({
              title: '',
              start: this.formatDate(currentDate),
            });
          }
          
          currentDate.setDate(currentDate.getDate() + 1);
        }
      }
  
      if (this.selectedDate) {
        let currentDate = new Date(this.selectedDate);
        let endDate = new Date(currentDate);
  
        if (this.selectedEndDate) {
          endDate = new Date(this.selectedEndDate)
        }else{
          endDate.setFullYear(currentDate.getFullYear() + 1); // Aumentar un año
        }
  
        const eventDate: any[] = [];
        while (currentDate <= endDate) { // Generar eventos hasta la fecha de finalización
          eventDate.push({
            id: eventDate.length,
            title: '',
            start: this.formatDate(currentDate),
          });
  
          if (this.frecuency == 'S'){
            currentDate.setDate(currentDate.getDate() + 7); // Aumenta 7 días (1 semana)
          }else if (this.frecuency === 'Q') {
            currentDate.setDate(currentDate.getDate() + 15); // Aumenta 15 días
          }else if(this.frecuency === 'M'){
            currentDate.setDate(currentDate.getDate() + 30); // Aumentar 30 días (1 mes aproximado)
          }else if(this.frecuency === 'P'){
            currentDate.setFullYear(currentDate.getFullYear() + 1); // Aumentar 1 año
          }else{
            break;
          }
        }
  
        events = eventDate;
      }
  
      if (this.selectedDates.length > 0){
        this.selectedDates.forEach((date) => {
          const formattedSDate = new Date(date).toISOString().split('T')[0];
          events.push({ title: '', start: formattedSDate });
        });
      }
  
      this.eventsFrecuency = events
      if(this.selectedDate && this.selectedEndDate){
        this.calendarOptions = {
          ...this.calendarOptions,
          events,
          validRange: {
            start: new Date(this.selectedDate)
          },
          views: {
            multiMonthFourMonth: {
              type: 'multiMonth',
              duration: { months: this.calculateMonths() + 1 },
              buttonText: 'Year',
            },
          },
          editable: true,
          droppable: true,
          eventDrop: this.handleEventDrop.bind(this),
          eventClick: this.handleEventClick.bind(this)
        };
      }else{
        this.calendarOptions = {
          ...this.calendarOptions,
          events,
          validRange: {
            start: new Date()
          },
          views: {
            multiMonthFourMonth: {
              type: 'multiMonth',
              duration: { months: 12 },
              buttonText: 'Year',
            },
          },
        };
      }
      this._fuseLoadingService.hide();
    }, 500);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    
    //const formattedDate = new Date(this.selectedDate).toISOString().split('T')[0];
    return `${year}-${month}-${day}`;
  }

  calculateMonths(){
    const startDate = new Date(this.selectedDate);
    const endDate = new Date(this.selectedEndDate);

    // Calcula la diferencia en años y meses
    const yearsDifference = endDate.getFullYear() - startDate.getFullYear();
    const monthsDifference = endDate.getMonth() - startDate.getMonth();

    // Convierte la diferencia en años a meses y agrega la diferencia en meses
    return yearsDifference * 12 + monthsDifference;
  }
  
  handleEventDrop(info: any): void {
    const event = info.event; // Evento movido
    const newStartDate = event.start; // Nueva fecha de inicio
    const eventId = event.id; // Identificador único del evento
  
    const updatedEvents = this.eventsFrecuency.map((e: any) => {
      if (e.id === Number(eventId)) {
        e.start = this.formatDate(newStartDate);
      }
      return e;
    });

    this.eventsFrecuency = updatedEvents;
  }

  handleEventClick(info: any) {
    if (confirm('Al eliminar el evento, no se podrá adicionar uno nuevo desde esta ventana, tendrá que acceder a la pestaña de Asignados e ir a Agenda de Eventos - A(x). ¿Deseas confirmar la eliminación de este evento?')) {
      const eventId = info.event.id;

      const updatedEvents = this.eventsFrecuency.filter(
        (event: any) => event.id !== Number(eventId)
      );
      
      info.event.remove(); // Elimina visualmente el evento del calendario
      this.eventsFrecuency = updatedEvents
    }
  }

  onSubmit(){
    //mandar solo tipo Days y "C" para mandar las fechas
    if(!this.isCalendarVisible){
      return
    }

    this.frecuency === 'W' ? this.updateFrequency() : this.createFrequency()
  }

  createFrequency(): void {
    let createFrequency: ICreateAppointment = { //FrequenciesAttributes
      type: 'C',
      subRouteId: this.data.subRouteId,
      dates: this.eventsFrecuency.map((event) => new Date(`${event.start}T00:00:00`)),
      businessPartners: (this.data.businessPartners || []).map((b, index) => ({
        businessPartnerId: b._id,
        //position: index + 1,
      })),
    };

    this.frequencyService.createManyAppointment(createFrequency).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
        this.dialogRef.close("success")
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al crear el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
      },
    });
  }

  updateFrequency(): void {
    let dataToSend: ICreateManyBPFrecuency = {
      businessPartnerIds: this.data.businessPartners.map((bp) => bp._id.toString())
    }

    this.subRouteFrequenciesBPService.createManyBusinessPartnerFromFrecuency(this.data.subRouteId, this.selectedFrecuency._id, dataToSend).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
        this.dialogRef.close("success")
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al crear el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
      },
    });
  }
}
